<template>
<b-row class="h-100">
    <b-colxx sm="12" md="5" class="mx-auto my-auto">
        <div class="logoBox">
            <img class="align-self-center login2Logo" src="/assets/img/hitable-login-logo-2.png">
<!--            <img class="align-self-center" src="/assets/img/hitable_logo.png">-->
            <!--      <h3 style="margin: 40px; font-size: 65px; font-weight: bolder;" class="text-center"><span style="color: #c11314;">HI</span>TABLE</h3>-->
        </div>
        <b-card>
            <!--        <div class=" image-side">-->
            <!--          <p class="text-white h2">-->
            <!--            Brand Admin Manager-->
            <!--          </p>-->
            <!--        </div>-->

            <div class="form-side">
                <h6 class="mb-4">{{ $t('user.login-title') }}</h6>
                <b-form @submit.prevent="formSubmit" class="av-tooltip tooltip-label-bottom">
                    <b-row align-v="center">

                        <b-colxx md="8">
                            <b-form-group :label="$t('user.username')" class="has-float-label mb-4">
                                <b-form-input type="text" v-model="$v.form.username.$model" :state="!$v.form.username.$error" />
                                <b-form-invalid-feedback v-if="!$v.form.username.required">{{ $t('user.required-id') }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group label="비밀번호" class="has-float-label mb-4">
                                <b-form-input type="password" v-model="$v.form.password.$model" :state="!$v.form.password.$error" />
                                <b-form-invalid-feedback v-if="!$v.form.password.required">{{ $t('user.required-password') }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-else-if="!$v.form.password.minLength || !$v.form.password.maxLength">비밀번호는
                                    4~16자리로 입력해주세요.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-colxx>

                        <b-colxx md="4" xs="4" xxs="12" align="center">
                            <!--                <b-button type="submit" variant="primary default" size="lg" :disabled="processing" :class="{'btn-multiple-state btn-shadow': true,-->
                            <!--                        'show-spinner': processing,-->
                            <!--                        'show-success': !processing && loginError===false,-->
                            <!--                        'show-fail': !processing && loginError }">-->
                            <!--                                <span class="spinner d-inline-block">-->
                            <!--                                    <span class="bounce1"></span>-->
                            <!--                                    <span class="bounce2"></span>-->
                            <!--                                    <span class="bounce3"></span>-->
                            <!--                                </span>-->
                            <!--                  <span class="icon success">-->
                            <!--                                    <i class="simple-icon-check"></i>-->
                            <!--                                </span>-->
                            <!--                  <span class="icon fail">-->
                            <!--                                    <i class="simple-icon-exclamation"></i>-->
                            <!--                                </span>-->
                            <!--                  <span class="label">로그인</span>-->
                            <!--                </b-button>-->

                            <b-button class="btn-shadow" type="submit" variant="primary default" size="lg" style="white-space: nowrap">
                                <span class="label">로그인</span>
                            </b-button>

                        </b-colxx>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-checkbox id="checkbox-rememberID" v-model="bRememberID" name="checkbox-rememberID">{{
                    $t('user.remember-id')
                  }}
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <div class="separator mb-5"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="d-flex justify-content-between align-items-center" v-if="mobile">
                                <router-link tag="a" :to="`/${this.$route.params.sitename}/user/forgot-password`">비밀번호 찾기
                                </router-link>
                                <!--                  |-->
                                <!--                  <router-link tag="a" :to="`/${this.$route.params.sitename}/user/forgot-id`">ID 찾기</router-link>-->
                                <!--                  |-->
                                <router-link tag="a" :to="`/${this.$route.params.sitename}/user/register`">회원 가입</router-link>
                            </div>
                            <div v-else>
                                회원가입, 비밀번호 찾기는 PC로 진행해주세요
                            </div>
                        </b-col>
                    </b-row>
                </b-form>
            </div>

        </b-card>

    </b-colxx>
</b-row>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import {
    validationMixin
} from "vuelidate";

import api from '../../constants/api';
import {
    reqGet,
    reqPost
} from "../../constants/request";
import {
    rescode,
} from "../../constants/common";
const {
    required,
    maxLength,
    minLength,
    email
} = require("vuelidate/lib/validators");

export default {
    data() {
        return {
            useCidAlimtalk: false,
            phoneNumber: '',
            storeCode: '',
            currentToken: '',
            changePWD: false,
            form: {
                username: this.$route.params.id === undefined ? null : this.$route.params.id,
                password: ""
            },
            bRememberID: true,
            mobile: '',
            fofo: false,
            storeName:'',
        };
    },
    mixins: [validationMixin],
    validations: {
        form: {
            password: {
                required,
                maxLength: maxLength(16),
                minLength: minLength(4)
            },
            username: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: {
        ...mapGetters(["currentUser", "processing", "loginError", "savedID", "siteName", "info", 'brandInfo'])
    },
    mounted() {

        this.mobileCheckLayout();
        console.log(this.savedID);
        if (this.savedID != null && this.form.username === null) {
            this.form.username = this.savedID
        }

        if (this.$route.path.includes('passLogin')) {
            this.changePWD = true
        }

        this.setSiteNameDefault();
        this.userReset();

    },

    methods: {

        ...mapActions(["setSiteName", "userReset", "login", "setBrandInfo", 'userInfo']),

        setSiteNameDefault: function () {
            this.setSiteName({
                SITE_NAME: this.$route.params.sitename
            });
        },
        mobileCheckLayout() {
            if (navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
                this.mobile = false;
            } else {
                this.mobile = true;
            }
        },
        formSubmit: function () {
            this.$v.$touch();
            this.$v.form.$touch();

            if (!this.$v.form.$anyError) {
                this.login({
                    username: this.form.username,
                    password: this.form.password,
                    bRememberID: this.bRememberID,
                    SITE_NAME: this.$route.params.sitename,
                    changePWD: this.changePWD
                });
            }
        },
        getStoreBasicInfo() {
            const reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoStr)

            this.$http.get(reqUrl, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    const data = res.data.data;
                    this.phoneNumber = data.basicInfo.phoneNumber;
                    this.storeCode = data.storeCode;
                    this.storeName = data.basicInfo.storeName;
                    // console.log()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        },
        cidSetData(fcmToken) {

            reqPost(
                api.changeAPI(this.siteName, api.basicURL + api.cid.fcmPush),
                this.currentUser.tokens.access.token, {
                    storeCode: this.storeCode,
                    storeName: this.storeName,
                    fcmToken: fcmToken,
                    phoneNumber: this.phoneNumber,
                    brandCode: this.info.brandCode,
                    brandName: this.brandInfo.brandName,
                    siteName: this.brandInfo.siteName,
                    cidUseStatus: this.useCidAlimtalk,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {

                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        getUserInfo() {
            this.userInfo()
        },

    },
    watch: {
        currentUser(val) {
            let vm = this;
            if (val.tokens.access.token && val.tokens.access.token !== "") {
                // this.getUserInfo();
                this.setBrandInfo();
                if (val.userRole === "STORE_MANAGER") {
                    // navigator.serviceWorker.getRegistrations().then(function (registrations) {
                    //     for (let registration of registrations) {
                    //         registration.register();
                    //     }
                    // });
                    this.getStoreBasicInfo();

                    const reqUrl = api.changeAPI(this.siteName, api.basicURL + api.cid.alimtalkSettings)

                    this.$http.get(reqUrl, {
                        headers: {
                            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                        }
                    }).then(res => {
                        if (res.data.code === "OK") {
                            const data = res.data.data;
                            vm.useCidAlimtalk = data.useCidAlimtalk;
                            if (!vm.useCidAlimtalk) {
                                // navigator.serviceWorker.getRegistrations().then(function (registrations) {
                                //     for (let registration of registrations) {
                                //         registration.unregister();
                                //     }
                                // });
                            }
                            if (val.userRole === "STORE_MANAGER" && this.useCidAlimtalk) {
                                Notification.requestPermission()
                                    .then((permission) => {
                                        // console.log('permission ', permission)
                                        if (permission !== 'granted') {
                                            alert('알림을 허용해주세요')
                                            return;
                                        }
                                    })

                                vm.$messaging.getToken({
                                    vapidKey: 'BJ-s-IVRFOpgc7lDWrg8Xk4ATqXD3CLbXflCOQD5fauShPLSCaYVyrYys5sk2yk-g0wX0iBhon9k0qYhzq-Htzo'
                                }).then((currentToken) => {
                                    if (currentToken) {
                                        // Send the token to your server and update the UI if necessary
                                        // ...
                                        vm.currentToken = currentToken;
                                        setTimeout(() => {
                                            vm.cidSetData(currentToken);
                                        }, 500);
                                        // console.log(currentToken)
                                    } else {
                                        // Show permission request UI
                                        console.log('No registration token available. Request permission to generate one.');
                                        // ...
                                    }
                                }).catch((err) => {
                                    console.log('An error occurred while retrieving token. ', err);
                                    // ...
                                });
                            } else {
                                navigator.serviceWorker.getRegistrations().then(function (registrations) {
                                    for (let registration of registrations) {
                                        registration.unregister();
                                    }
                                });
                            }
                            // console.log()
                        } else {
                            throw 400
                        }
                    }).catch(err => {
                        alert(err.response.data.message);
                    })
                } else {
                    // navigator.serviceWorker.getRegistrations().then(function (registrations) {
                    //     for (let registration of registrations) {
                    //         registration.unregister();
                    //     }
                    // });
                }

                setTimeout(() => {
                    this.$router.push("/" + this.$route.params.sitename);
                }, 200);
            }
        },
        loginError(val) {
            if (val != null) {
                var errMsg = '';
                errMsg = val.response.data.message;
                // if(val.response.data.code == "UNAUTHENTICATED") {
                //   errMsg = "비밀번호를 다시한번 확인해 주세요.";
                // }
                // if(val.response.data.code == "NOT_FOUND") {
                //   errMsg = "아이디를 다시한번 확인해 주세요.";
                // }
                this.$notify("error", "Login Error", errMsg, {
                    duration: 3500,
                    permanent: false
                });

            }
        }
    }
};
</script>

<style scoped>
.logoBox {
    text-align: center;
}

.logoBox img {
    /* display: block; */
    /*margin: 20px auto;*/
}

.logoBox img:first-child {
    width: 120px;
}

/* .login2Logo{
  margin-top: 10px;
} */
</style>
